'use strict';

angular.module('shiftTraderApp')
  .controller('HeaderCtrl', function ($scope, Session) {
    $scope.me = Session.me;
    // loggedIn var describes whether there is a logged-in user currently using the site
    $scope.loggedIn = Session.isLoggedIn();

    $scope.$on('updatedSessionMe', function(event, isLoggedIn) {
      if (isLoggedIn) {
        $scope.me = Session.me;
      }
    });

    $scope.$on('loginStateChanged', function(event, data) {
      $scope.loggedIn = data.state;
    });
  });
